import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Pad = styled.div`
    padding: 10px;
    background-color: #eee;
    min-width: 500px;
`;

export const Title = styled.div`
    font-weight: bold;
`;

export const InteractionPad = styled.div`
    padding: 10px;
    background-color: #ccc;
`;

export const Item = styled.div`
    margin-bottom: 10px;
`;

export const Content = styled.div`
    white-space: pre-wrap;
    word-break: break-all;
`;
